import { localStorageSideNav } from '../constants';
import { FETCH_SIDE_NAV, SET_SIDE_NAV } from './types';

export function fetchSideNav() {
  let request = true;
  if (localStorage.getItem(localStorageSideNav)) {
    request = localStorage.getItem(localStorageSideNav) === 'true';
  }
  return {
    type: FETCH_SIDE_NAV,
    payload: request,
  };
}

export function setSideNav(value) {
  localStorage.removeItem(localStorageSideNav);
  localStorage.setItem(localStorageSideNav, value);

  return {
    type: SET_SIDE_NAV,
    payload: value,
  };
}
